
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 90 12","overflow":"visible"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.762 9.302h-14.81v2.296h14.81V9.302zM49.917 9.302h-15.53v2.296h15.53V9.302zM1.629.307h16.78v2.296h-7.282v8.981H8.844V2.616H1.63V.306zM33.748.307H18.953v2.296h14.795V.307zM26.887 4.9h-6.67v2.295h6.67V4.9zM36.452.308h13.464v2.296h-12.01s-.773.068-.95.379c-.178.313-.409.923.013 1.426.421.504 1.06.38 1.06.38h11.887V7.11H36.683s-1.59-.257-2.214-1.97c-.04-.938 0-2.621 0-2.621s.3-1.562 1.983-2.214v.002zM50.664.307h16.779v2.269h-7.269v8.993h-2.31V2.602h-7.2V.307zM69.59.307l8.314 8.3L86.531 0l1.577 1.598L77.931 12 67.973 1.91 69.59.308z"}})])
          )
        }
      }
    